import { UntypedFormControl, ValidationErrors } from '@angular/forms';

const NoWhitespaceValidator = (control: UntypedFormControl): ValidationErrors | null => {
	const isWhitespace = (control.value || '').trim().length === 0;
	return isWhitespace ? { whitespace: true } : null;
};

export { NoWhitespaceValidator };
